<template>
    <list-group-item :action="clickAction" color="primary">
        <i class="fas fa-eye"></i> <strong>Pending Home Vision Application</strong>
    </list-group-item>
</template>

<script type="text/javascript">
    import UIComponents from '@/components/UI/index.vue';

    export default {
        components: {
            ...UIComponents,
        },

        props: {
            homeVisionId: {
                type: [String, Number],
                required: true,
            },
        },

        emits: ['click'],

        methods: {
            clickAction() {
                this.$emit('click');
                this.$router.push('/owners/maintenance/home-vision/application/'+this.homeVisionId);
            },
        },
    }
</script>